import { useEffect } from 'react';
import { AuthLayout } from '@/bundle/Auth/ui/AuthLayout/AuthLayout';
import { SwitchRole } from '@/bundle/pages/SwitchRolePage/ui/SwitchRole';
import { useUser } from '@/context/userContext';
import { useNavigate } from 'react-router';
import { UserRoleType } from '@/const/user';
import { DASHBOARD_REDIRECT_MAP } from '../../Auth/LoginFlow/LoginPage/const/const';
import { AdBanner } from '@/bundle/shared/components/banner/AdBanner/AdBanner';
import { getAccessDeniedPath } from '../AccessDeniedPage/path/path';
import { AMPLITUDE_USER_ROLE_LABEL, amplitudeService } from '@/services/amplitudeService/amplitudeService';
import { AMPLITUDE_EVENTS } from '@/services/amplitudeService/amplitudeEvents';
import { useHasAnyOrganizationAdminRole } from '@/bundle/shared/hooks/useHasAnyOrganizationAdminRole';
import { authTokenService } from '../../shared/services/authTokenService';
import { decodeToken } from '@/helpers/tokenHelpers';
import { AccessTokenType } from '@/types/sharedTypes';
import { getRolesList } from '@/helpers/userHelpers';

export const SwitchRolePage = () => {
  const navigate = useNavigate();
  const { hasMultipleUserRoles, setRole } = useUser();
  const { hasAnyOrganizationAdminRole } = useHasAnyOrganizationAdminRole();
  const tokens = authTokenService.getTokens();

  useEffect(() => {
    if (!hasMultipleUserRoles) {
      navigate(getAccessDeniedPath());

      return;
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hasMultipleUserRoles]);

  if (!tokens || !tokens?.access) return;

  const { active_roles } = decodeToken<AccessTokenType>(tokens?.access);
  const activeRoles = getRolesList(active_roles);

  const switchRole = (selectedRole: UserRoleType) => {
    setRole(selectedRole);

    const redirectUrl = DASHBOARD_REDIRECT_MAP[selectedRole];

    amplitudeService.logEvent(AMPLITUDE_EVENTS.SwitchRoleSelectDashboardSuccess, {
      selectedRole: AMPLITUDE_USER_ROLE_LABEL[selectedRole],
    });

    navigate(redirectUrl);
  };

  const navigateBack = () => {
    navigate(-1);
  };

  return (
    <AuthLayout banner={hasAnyOrganizationAdminRole ? null : <AdBanner isClosable={false} />}>
      <SwitchRole activeRoles={activeRoles} onBack={navigateBack} onSelect={switchRole} />
    </AuthLayout>
  );
};
